import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import {
  type ListaItens,
  type SeletorItem,
} from '@Lar21/imaginii-web-components/vue'

import {
  encontrarOpcaoDoCatalogo,
  preservarEstadoSemSelecaoVazia,
  prepararEstadoSomenteLeitura,
} from '@next/compartilhados/catalogos/apresentacao/estado-seletor-catalogo'

import {
  CHAVE_I18N_CATALOGO_EMPREGADOR,
  criarEstadoSeletorCatalogoEmpregador,
  criarPropriedadesPontotelSeletorEmpregador,
  extrairValorDoSeletorCatalogoEmpregador,
  filtrarOpcoesEmpregador,
} from './adaptador-catalogo-empregador'
import { usarCatalogoEmpregador } from './usar-catalogo-empregador'
import type {
  FiltrosCatalogoEmpregador,
  OpcaoEmpregador,
  SelecaoCatalogoEmpregador,
} from '../catalogo-empregador.tipos'

type Props = Readonly<{
  modelValue: SelecaoCatalogoEmpregador
  selecaoMultipla?: boolean
  tamanho?: 'P' | 'M' | 'G'
  predicado?: (empregador: OpcaoEmpregador) => boolean
  filtros?: FiltrosCatalogoEmpregador
  desabilitado?: boolean
  somenteLeitura?: boolean
  permiteSelecionarTodos?: boolean
  permiteLimpar?: boolean
  habilitarDuploClique?: boolean
  label?: string
  placeholder?: string
  mensagemErro?: string | null
  info?: string | null
}>


export default /*@__PURE__*/_defineComponent({
  __name: 'CatalogoEmpregador',
  props: {
    modelValue: { type: [Object, Array, null], required: true },
    selecaoMultipla: { type: Boolean, required: false, default: false },
    tamanho: { type: String, required: false, default: 'M' },
    predicado: { type: Function, required: false },
    filtros: { type: Object, required: false },
    desabilitado: { type: Boolean, required: false, default: false },
    somenteLeitura: { type: Boolean, required: false, default: false },
    permiteSelecionarTodos: { type: Boolean, required: false, default: true },
    permiteLimpar: { type: Boolean, required: false, default: true },
    habilitarDuploClique: { type: Boolean, required: false, default: false },
    label: { type: String, required: false },
    placeholder: { type: String, required: false },
    mensagemErro: { type: [String, null], required: false, default: null },
    info: { type: [String, null], required: false, default: null }
  },
  emits: ["update:modelValue", "filtrando-itens", "duplo-clique", "update:selecionouTodos"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props

const emit = __emit

const { t } = useI18n()
const catalogo = usarCatalogoEmpregador(computed(() => !props.somenteLeitura))

const opcoesFiltradas = computed(() => filtrarOpcoesEmpregador(
  catalogo.itens.value,
  props.filtros,
  props.predicado,
))

const estadoSeletor = computed(() => prepararEstadoSomenteLeitura(
  criarEstadoSeletorCatalogoEmpregador(
    opcoesFiltradas.value,
    props.modelValue,
    props.selecaoMultipla,
  ),
  props.somenteLeitura,
  props.modelValue,
))

const erroExibido = computed(() => catalogo.erro.value
  ? t(`${CHAVE_I18N_CATALOGO_EMPREGADOR}.erroBusca`)
  : props.mensagemErro)

const propriedadesSeletor = computed(() => (
  criarPropriedadesPontotelSeletorEmpregador({
    traduzir: t,
    ...(props.label !== undefined ? { label: props.label } : {}),
    ...(props.placeholder !== undefined
      ? { placeholder: props.placeholder }
      : {}),
    erro: erroExibido.value,
  })
))

const alterarSelecao = (estado: ListaItens): void => {
  emit(
    'update:modelValue',
    extrairValorDoSeletorCatalogoEmpregador(
      preservarEstadoSemSelecaoVazia(
        estado,
        estadoSeletor.value,
        props.permiteLimpar,
      ),
      opcoesFiltradas.value,
      props.selecaoMultipla,
    ),
  )
}

const tratarDuploClique = (item: SeletorItem): void => {
  const opcao = encontrarOpcaoDoCatalogo(opcoesFiltradas.value, item)
  if (opcao) emit('duplo-clique', opcao)
}


const __returned__ = { props, emit, t, catalogo, opcoesFiltradas, estadoSeletor, erroExibido, propriedadesSeletor, alterarSelecao, tratarDuploClique }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})